
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 35.61 35.61"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{staticClass:"a",attrs:{"cx":"17.8","cy":"17.8","r":"17.8"}}),_c('path',{staticClass:"b",attrs:{"d":"M23.5 29.2H12.1v-1.8q2.94 0 3.72-.84t.78-4h-.3a4.64 4.64 0 01-1.78 1.65 5.25 5.25 0 01-6.14-.93 5.29 5.29 0 010-7.44 5.06 5.06 0 013.72-1.53 4.78 4.78 0 011.32.18 5.22 5.22 0 01-.87-2.88A5.22 5.22 0 0117.8 6.4a5.22 5.22 0 015.25 5.25 5.22 5.22 0 01-.87 2.88 4.78 4.78 0 011.32-.18 5.22 5.22 0 015.25 5.25 5.23 5.23 0 01-7.66 4.65 4.67 4.67 0 01-1.79-1.65H19q0 3.12.78 4t3.72.84z"}})])
          )
        }
      }
    